<p-dialog [(visible)]="dialogFormVisible"
          [header]="'page.'+this.transPartKey+'.title' | translate"
          [modal]="true" [styleClass]="'p-fluid user-views-dialog'"
          [closeOnEscape]="true" (onShow)="dialogFormVisibleChange.emit(true)"
          (onHide)="dialogFormVisibleChange.emit(false)"
          appendTo="body" position="top"
          [resizable]="false">
  <ng-template pTemplate="content">
    <app-user-views></app-user-views>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="closeDialog()"
            [label]="'common.dialog.close' | translate"
            class="p-button-warning p-button-sm"></button>
  </ng-template>
</p-dialog>
